import React, {  useEffect, useState } from 'react'; 
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import { Divider } from '@mui/material';
import { apiUrl } from "../config/default";
import ExperimentPageImages from "./expression-images";
import ExpressionTissues from "./expression-tissues";
import AllelicCurationOverview from "./allelic-curation-overview";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import CloseIcon from '@mui/icons-material/Close'; 
import CircularProgress from '@mui/material/CircularProgress';
import IgvTrackViewer from './track-viewer';
import { backboneTranslate } from "./dictionaries";

export default function ElementContent(props: any) {
    const { data } = props;
    const [contentData, setContentData] = useState<any>(null); 
    const [sequenceModalopen, setSequenceModalopen] = useState<any>(false);
    const [isReady, setIsReady] = React.useState(false);
    const [coordModalopen, setCoordModalopen] = useState<any>(false);

    useEffect(() => {
      if(!data ||
          !("rowData" in data) || 
          !("vistaId" in data.rowData) 
        )
      {
        setContentData(null); 
        return;
      }
      
      const fetchData = async () => {
        let url = apiUrl + "/catalogs/externalElementPage?vistaid=" + data.rowData.vistaId ;
        let alleleId = 0;
        let stage = "";
        let backbone = "";
        if( data.rowData.alleleId) {
          alleleId = data.rowData.alleleId;
        }
        else {
          alleleId= 0;
        }
        url = url + "&alleleId=" + alleleId;
        if(data.rowData.stage) {
          stage = data.rowData.stage;
          url = url + "&stage=" + stage;
        }

        
        if(data.rowData.backbone) {
          backbone = data.rowData.backbone;
          url = url + "&backbone=" + backbone;
        }

        
        const contentListDataResult = await fetch(url)
                                      .then(res => res.json());
        if(contentListDataResult && contentListDataResult.data && contentListDataResult.data.length > 0)
        {
          //set content list, same vistaid different alleleid
          let content = contentListDataResult.data.find((item:any)=>{
            return item.vista_id===data.rowData.vistaId && item.allele_id===data.rowData.alleleId && item.stage === stage && item.backbone === backbone;
          });
          if(!content) {
            content = contentListDataResult.data[0];
          }
          content["current_stage"] = stage;
          let all_stages = [];
          let all_backbones = [];
          let expressions = [];
          let all_exp_hiers = [];
          for(let i=0; i < contentListDataResult.data.length; i+=1) {
              all_stages.push(contentListDataResult.data[i].stage);
              all_backbones.push(contentListDataResult.data[i].backbone);
              expressions.push(contentListDataResult.data[i].curation_status);
              all_exp_hiers.push(contentListDataResult.data[i].exp_hier);
          }
          content["all_stages"] = all_stages;
          content["all_backbones"]  = all_backbones;
          content["expressions"] = expressions;
          content["all_exp_hiers"] = all_exp_hiers;

          //set current page contnet
          setContentData(content);
          setIsReady(true);
        }
        else
        {
          setContentData(null); 
          setIsReady(true);
        }

      };

  
      fetchData()
      .catch((error)=>{
      });

    }, [data]);


    const updateExperimentTitlePage = () => {
      // After successful API call: update page title to include element info
      document.title = 'Experiment ' + contentData["vista_id"] + "." + contentData["allele_id"] + "- Vista Enhancer Browser"; 
    }
   
    


    const expressionsReducer = (expressions:any) => {
            if( expressions === null || expressions[0] === null)
                return null;
            //find duplicated stages and show the positive one if that exit
            let lookup:any = {};
            for(let expItem of expressions)
            {
                if(expItem.stage in lookup &&  
                    lookup[expItem.stage].curation_status!=="positive")
                {
                    lookup[expItem.stage].curation_status = expItem.curation_status;
                    lookup[expItem.stage].data = expItem;
                }
                else if(!(expItem.stage in lookup))
                {
                    lookup[expItem.stage] = {"curation_status": expItem.curation_status,
                                             "data": expItem}; 
                }
            }
      
            //flatten filtered list
            let renderList = [];
            for(let key in lookup)
            {
                renderList.push(lookup[key].data); 
            }
            return renderList;
    };

    const renderStageList = () => { 
      if(!contentData || !contentData.expressions) 
        return null;


      if(typeof contentData.expressions === "string") {
        let exp = contentData;
        let circleColor= "orange";
        let textColor = "black";
        let text = "curated allele";

        if(contentData.curation_status[0] && contentData.curation_status[0]==="positive")
        {
          circleColor = "blue";
          textColor = "white";
          text = "positive";
        }
        else if(contentData.curation_status[0] && contentData.curation_status[0]==="negative") {
          circleColor = "grey";
          text = "negative";
        }
        let _key = Math.floor(Math.random() * 9999); 

        return (
          <div key={exp.stage+_key} > 
            <div style={{"display":"flex",alignItems: "flex-start",gap:"1%", width:"100%"}}>
              <div style={{padding:"10px 0 10px 0", width:"7%", textAlign:"center"}}>
                <div className="p-button p-button-rounded"
                  style={{"backgroundColor":circleColor, "color":textColor, textDecoration: "none"}}
                  >
                  {text}
                </div> 
              </div>
              <div style={{width:"92%", padding:"10px 0  0 10px", borderLeft:"1px solid rgba(0, 0, 0, 0.12)"}}>
                Transgenesis:&nbsp; 
                {backboneTranslate(exp.backbone, "transgenesisType")}
                <br/>
                Promoter:&nbsp; 
                {backboneTranslate(exp.backbone, "promoter")}
                <br/>
                <br/>
  
                <ExpressionTissues exprStage={exp.stage} exprItem={exp}></ExpressionTissues>
  
                <br/>
                { /* Negative experiments should not display images externally */
                  (exp.curation_status && exp.curation_status==="positive") && 
                  <ExperimentPageImages exprStage={exp.stage} exprItem={exp}></ExperimentPageImages>
                }
                {
                  (!("curation_status" in exp) || exp.curation_status ==="negative") && 
                  <>
                  <Alert severity="info">
                    This element did not show observable enhancer activities at this stage using this transgenic strategy.<br/>
                    We call an enhancer negative when at least two high-copy transgenics were obtained using enSERT (or at least 
                    three using random transgenesis) and no reproducible pattern of expression was observed. This does not mean 
                    that this sequence is not an enhancer at another time point, or a weak enhancer at this time point, 
                    but below the detectable range at our level of resolution.
                  </Alert>
                  <br/>
                  </>
                }
              </div>
            </div>
            <Divider></Divider> 
          </div>
          );      
      }
      else {
      let listed: any[] = [];
      let stage_index = 0;
      if(data.rowData.all_stages) {
        for(let i=0; i< contentData.stage.all_stages; i+=1) {
          if(contentData.all_stages[i] === contentData["current_stage"]) {
            stage_index = i;
            break;
          }
        }
      }
      let exp = contentData;
      let circleColor= "orange";
      let textColor = "black";
      let text = "curated allele";
        if(contentData.expressions[stage_index] && contentData.expressions[stage_index]==="positive")
        {
          circleColor = "blue";
          textColor = "white";
          text = "positive";
        }
        else if(contentData.expressions[stage_index] && contentData.expressions[stage_index]==="negative") {
          circleColor = "grey";
          text = "negative";
        }
        let _key = Math.floor(Math.random() * 9999); 
       listed.push (
          <div key={contentData.stage+_key} > 
            <div style={{"display":"flex",alignItems: "flex-start",gap:"1%", width:"100%"}}>
              <div style={{padding:"10px 0 10px 0", width:"7%", textAlign:"center"}}>
                <div className="p-button p-button-rounded"
                  style={{"backgroundColor":circleColor, "color":textColor, textDecoration: "none"}}
                  >
                  {text}
                </div> 
              </div>
              <div style={{width:"92%", padding:"10px 0  0 10px", borderLeft:"1px solid rgba(0, 0, 0, 0.12)"}}>
                Transgenesis:&nbsp; 
                {backboneTranslate(contentData.backbone, "transgenesisType")}
                <br/>
                Promoter:&nbsp; 
                {backboneTranslate(contentData.backbone, "promoter")}
                <br/>
                <br/>
  
                <ExpressionTissues exprStage={contentData.stage} exprItem={contentData} index={stage_index}></ExpressionTissues>
  
                <br/>
                {/** original code for images went here */}
                {
                  (!contentData.expressions[stage_index] || contentData.expressions[stage_index]==="negative") && 
                  <>
                  <Alert severity="info">
                    This element did not show observable enhancer activities at this stage using this transgenic strategy.<br/>
                    We call an enhancer negative when at least two high-copy transgenics were obtained using enSERT (or at least 
                    three using random transgenesis) and no reproducible pattern of expression was observed. This does not mean 
                    that this sequence is not an enhancer at another time point, or a weak enhancer at this time point, 
                    but below the detectable range at our level of resolution.
                  </Alert>
                  <br/>
                  </>
                }
              </div>
            </div>
            <Divider></Divider> 
          </div>
          );
      
      return listed;
      }
    };


    const renderExternalNote = () => {
      if(!contentData || !contentData.external_note)
        return null;
    return(
      <span><b>External Note:</b> {contentData.external_note}</span>
    )
      
    }

    const renderImages = () => {
    if(!contentData || !contentData.exp_hier || !contentData.curation_status || contentData.curation_status === "negative")
      return(<span><i>No data available.</i></span>);
    
    let image_render: any[]  = [];
    let stage_index = 0;
    if(data.rowData.all_stages) {
      for(let i=0; i < contentData.all_stages.length; i+=1) {
        if(contentData.all_stages[i] === data.rowData.all_stages) {
          stage_index = i;
          break;
        }

      }
    }
      image_render.push(
        <ExperimentPageImages exp_hier={contentData.exp_hier} index={stage_index}></ExperimentPageImages>
      );
    return(
        <>
        <b>Developmental stage images:</b>
              <br></br>
        {image_render}
        </>
      );
    };

    

    const renderGenomePosition = (genome:string) => {
          if(!contentData) {
            return null;
          }
          let genome_browser_url = "https://genome.ucsc.edu/cgi-bin/hgTracks?db=";
          let coord = "";
          let coord_ucsc_link = "";
          if(genome === 'hg38')
            coord = contentData.coordinate_hg38;
          else if (genome === "mm10")
            coord = contentData.coordinate_mm10;
          else
            coord = contentData.coord;
          if(coord) {
            
          
          // alter the range by +- 2000 bps to show the surroundings of the track;
          let coord_elements = coord.split(/-|:/);
          let start_new = Number(coord_elements[1]) - 2000;
          let end_new = Number(coord_elements[2]) + 2000;
          coord_ucsc_link = coord_elements[0] + ":" +  start_new + "-" + end_new;
          

          genome_browser_url += genome + "&position=" + coord_ucsc_link + "&hideTracks=1&vistaEnhancersBb=full&wgEncodeGencodeSuper=full&Conservation=full&pix=1280";
          return(
            <span><a href={genome_browser_url} target='_blank' rel='noreferrer'>{coord}</a></span>
          );
        }
        else {
          return(<span>
            Not Available
          </span>);
        }
    }


    const renderFlankingGenes =(genome:string) => {
      if (!['hg38', 'mm10'].includes(genome)) {
        genome = 'hg38';
      }     
      if(!contentData) {
        return null;
      }
      let genes = "";
      let taxid = 9606;
      if(genome === 'hg38') {
        genes = contentData.bracket_hg38;
        taxid = 9606;
      }
      else {
        genes = contentData.bracket_mm10;
        taxid = 10090;
      }
      if(genes) {
      
        let gene_list = genes.split("-");
        let gene_search = "";
        if(gene_list.length > 1) {
          for(let i =0; i < gene_list.length; i+=1) {
            gene_search += gene_list[i] + "[GN] OR ";
          }
          gene_search = gene_search.replace("/ OR $/", '');
        }
        else {
          let gene_ed = gene_list[0].split(" ");
          gene_search = gene_ed[0] + "[GN]";
        }
        let url = "https://www.ncbi.nlm.nih.gov/gene/?term=(" + gene_search +")+AND+" + taxid + "%5BTaxonomy+ID%5D";

        return(
          <span><a href={url} target='_blank' rel='noreferrer'>{genes}</a></span>
        );
      }
      else {
        return(<span>
          Not Available
        </span>)
      }
    }

    const additionalCoordinatesViewer = () =>{
      if(!contentData || !contentData.coordinate_hg38)
        return null;
      return(
        <Dialog
        open={coordModalopen}
        onClose={handleCoordModalClose} 
        >
          <DialogTitle sx={{ m: 0, p: 2 }}>  
                  Corresponding Human/Mouse Genomic Elements
                  <IconButton
                    aria-label="close"
                    onClick={handleCoordModalClose}
                    sx={{
                      position: 'absolute',
                      right: 8,
                      top: 8,
                      color: (theme) => theme.palette.grey[500],
                    }}
                  >
                    <CloseIcon />
                  </IconButton> 
              </DialogTitle>
          <DialogContent  >
            <TableContainer component={Paper}>
              <Table sx={{ maxWidth: 550 }} aria-label="simple table">
                <TableHead>
                  <TableRow style={{"backgroundColor":"#8fb5ba"}}>
                    <TableCell></TableCell>
                    <TableCell><i>Homo sapiens</i> (hg38)</TableCell>
                    <TableCell><i>Mus musculus</i> (mm10)</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell><b>Coordinates</b></TableCell>
                    <TableCell>{renderGenomePosition('hg38')}</TableCell>
                    <TableCell>{renderGenomePosition('mm10')}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell><b>Flanking Genes</b></TableCell>
                    <TableCell>{renderFlankingGenes('hg38')}</TableCell>
                    <TableCell>{renderFlankingGenes('mm10')}</TableCell>
                  </TableRow>
                  </TableBody>
                  </Table>
              </TableContainer>
              <span style={{fontSize:"12px"}}>Click on a coordinate to visit the corresponding UCSC Browser track, or a gene name to visit the corresponding page in Entrez.</span>
            </DialogContent>
          </Dialog>
      )
    };

    const handleCoordModalOpen = () => {
      setCoordModalopen(true);
    };
    const handleCoordModalClose = () => {
      setCoordModalopen(false);
    };


    const handleSequenceModalOpen = () => {
      setSequenceModalopen(true);
    };


    const handleSequenceModalClose = () => {
      setSequenceModalopen(false);
    };

    const sequenceViewer = () => {
      if(!contentData || !contentData.seq)
        return null;
      return(
        <Dialog
              open={sequenceModalopen}
              onClose={handleSequenceModalClose} 
            >
              <DialogTitle sx={{ m: 0, p: 2 }}>  
                  Sequence
                  <IconButton
                    aria-label="close"
                    onClick={handleSequenceModalClose}
                    sx={{
                      position: 'absolute',
                      right: 8,
                      top: 8,
                      color: (theme) => theme.palette.grey[500],
                    }}
                  >
                    <CloseIcon />
                  </IconButton> 
              </DialogTitle>
              <DialogContent dividers style={{overflow: "auto", wordBreak: "break-word", fontFamily: "Courier"}}>
                {contentData.seq} 
              </DialogContent>  
            </Dialog>
      )
    };



    const renderAllelicCuration = () => {
      if(!contentData || !contentData.all_exp_hiers || contentData.allelic_curation.length === 0) 
        return null;
      let rows: any[] = [];
      var selected_exp_hier = "";
      for(var i = 0; i < contentData.all_stages.length; i++) {
          if(contentData["all_stages"][i] === contentData["current_stage"]) {
            selected_exp_hier = contentData["all_exp_hiers"][i];
            break;
          }
      }
      for(let i=0; i < contentData.allelic_curation.length; i +=1) {
        if(contentData.allelic_curation[i].refExp === contentData.exp_hier) {
          rows.push(<AllelicCurationOverview refId={contentData.vista_id + "." + contentData.allele_id} exprItem={contentData} index={i}></AllelicCurationOverview>)
        }

      }
      return(
        <div>
          <br/>
          <br/> 
          <b>Related Experiments:</b>
        <br/>
        <span><i>Note: dash indicates same value as current experiment</i></span>
        <br/>
        <Table>
        <TableHead>
            <TableRow style={{'backgroundColor':'#8fb5ba'}}>
                <TableCell>Vista ID</TableCell>
                <TableCell>Organism</TableCell>
                <TableCell>Element Description</TableCell>
                <TableCell>backbone</TableCell>
                <TableCell>Promoter</TableCell>
                <TableCell>Transgenesis</TableCell>
                <TableCell>Stage</TableCell>
                <TableCell colSpan={3}>Comparison<br/>(Overview)</TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
        {rows} 
        </TableBody>
        </Table>  
        </div>     
        )
    };


    




    if(!contentData)
    {
      if(!isReady) {
        return(<>
        
        <div style={{minHeight:"70vh", background:"white",opacity:"1.0",zIndex: 100,position: 'fixed', top: 0,right: 0,bottom: 0,left: 0}}>
          <CircularProgress
              variant="indeterminate"
              disableShrink 
              size={100}
              sx={{ 
                  position: 'absolute',
                  marginLeft: "auto",
                  marginRight: "auto",
                  left: 0,
                  right: 0,
                  top:"50%",
                  textAlign: "center",
                  zIndex: 111
              }}
          /> 
          </div>
          
          <Alert severity="info" style={{margin:"20vh 0 auto 0"}}>
                <b>Loading page contents...</b>
              </Alert>
          
        
        </>);
      }
      else {
      return (
              <> 
              <Alert severity="info" style={{margin:"20vh 0 auto 0"}}>
                <b>No match found for your search!</b>
              </Alert>
              </>
              );
            }
    }
    
    return (
        <div>
          {updateExperimentTitlePage()}
            <h4 style={{"color":"#aaa"}}>Experiment /</h4>
            <h1>
            {(contentData && "vista_id" in contentData) && contentData.vista_id}.{(contentData && "allele_id" in contentData) && contentData.allele_id}
            </h1> 
            <br/>
            <b>Overview:</b>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow style={{"backgroundColor":"#8fb5ba"}}>
                <TableCell><b>Organism</b></TableCell>
                <TableCell><b>Genome Assembly</b></TableCell>
                <TableCell><b>Genome Coordinates</b></TableCell>
                <TableCell><b>Stage</b></TableCell>
                <TableCell><b>Backbone</b></TableCell>

                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>{contentData.organism}</TableCell>
                  <TableCell>{contentData.assembly}</TableCell>
                  <TableCell>{renderGenomePosition(contentData.assembly)}</TableCell>
                  <TableCell>{contentData.current_stage}</TableCell>
                  <TableCell>{contentData.backbone}</TableCell>
                </TableRow>
              </TableBody>
              </Table>
            </TableContainer>
            <br/>
            <br/>
            <br/>
            {(contentData.coordinate_hg38||contentData.coordinate_mm10) &&
            <div>
            <b>Corresponding Reference Genomic Elements:</b>&nbsp;<span><i>(click to display)</i></span>
            
              
              <IconButton aria-label="Show Coordinates" onClick={handleCoordModalOpen}>
                <OpenInNewIcon />
              </IconButton>
              {additionalCoordinatesViewer()}
            <br/><br/>
            </div>}
            <b>Sequence:</b>&nbsp;<span><i>(click to display)</i></span>
            {(contentData) &&  
              <IconButton aria-label="Show Sequence" onClick={handleSequenceModalOpen}>
                <OpenInNewIcon />
              </IconButton>
              
            } 
            {sequenceViewer()}
            <br/>
            <br/> 
            <br/> 
            <b>Experiment details:</b>&nbsp;
            <br/> 
            <br/>  
            <Divider></Divider>
            {renderStageList()}
            <br/>
            
            {renderExternalNote()}
            <br/>
            <br/>
            <div>
            {renderImages()}
            </div>
            
            {renderAllelicCuration()}
            <br/>
            <br/>

        </div>
        
      );
    
      

    
  }